import { store, getContext, getElement } from '@wordpress/interactivity';

const { state } = store('gt/ctv/hebergement/inventaire', {
    actions: {
        toggleItem: (e) => {
            const context = getContext();
            const key = e.target.getAttribute('data-wp-key');
            context.isOpen[key] = !context.isOpen[key];
        },
    },
});
